module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/logo_teams.2806c5625995dc0f79c4747b5de9d43d.svg";